/* removes all fields whose value is a blank string */

export function removeBlanks<T>(obj: T): Partial<T> {
  const newObj: Partial<T> = {}; // Partial<T> makes all properties of T optional

  for (const key in obj) {
    const value = obj[key as keyof T]; // Type-safe access to properties

    if (typeof value === 'string' ? value !== '' : !!value) {
      // Check for string and empty or any other falsy value
      newObj[key as keyof T] = value;
    }
  }
  return newObj;
}

export function filterObj<T>(obj: Record<string, T>, predicate: (key: string, val: T) => boolean): Record<string, T> {
  const out: Record<string, T> = {};
  for (const key in obj) {
    if (Object.hasOwn(obj, key) && predicate(key, obj[key])) {
      out[key] = obj[key];
    }
  }
  return out;
}
